import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'email_automatic_sendings',
  namespace: 'automaticSending',
  mountedUrl: '/email/automatic-sendings',
  title: 'Automatic sendings',
  columns: [
    { attribute: 'type', label: 'code type' },
    { attribute: 'name' },
    { attribute: 'activated', label: 'activated', value: (o) => o.activated ? <i className="fas fa-check" /> : null },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/automatic-sending/containers/Listing.jsx